module.exports = __webpack_public_path__ + "static/media/new-text-question-pink.3581cb33.svg";